import { history } from "./history";
import LayerGroups from "../config/initialLayerGroups";
import { getUniqueRegionList } from "../data/countries";
import { REGIONS_2 } from "../constants/constants";

export const pathLocation = history.location.pathname;

export const layerGroups = pathLocation.includes(REGIONS_2.sadc.path)
  ? LayerGroups(REGIONS_2.sadc.name)
  : pathLocation.includes(REGIONS_2.ecowas.path)
  ? LayerGroups(REGIONS_2.ecowas.name)
  : pathLocation.includes(REGIONS_2.ecowas.path)
  ? LayerGroups(REGIONS_2.ecowas.name)
  : pathLocation.includes(REGIONS_2.africa.path)
  ? LayerGroups(REGIONS_2.africa.name)
  : [];

export const countriesList = pathLocation.includes(REGIONS_2.sadc.name)
  ? getUniqueRegionList(REGIONS_2.sadc.name)
  : pathLocation.includes(REGIONS_2.ecowas.name)
  ? getUniqueRegionList(REGIONS_2.ecowas.name)
  : pathLocation.includes(REGIONS_2.africa.name)
  ? getUniqueRegionList(REGIONS_2.africa.name)
  : pathLocation.includes(REGIONS_2.east.name)
  ? getUniqueRegionList(REGIONS_2.east.name) //needs to be developed since there are no east african countries in the list
  : [];
